import { mutationOptions } from "@tanstack/react-query";

import { api } from "@platform/core/api";
import { queryClient } from "@platform/core/query";
import type { CommunicationType } from "./communication.types";

// `type` marks the kind in the shared communication table, so staff can view
// each kind on its own.
export const sendCommunicationMutation = mutationOptions({
	mutationFn: (vars: { type: CommunicationType; body: string }) =>
		api.post("/platform/communication", vars),
	// Refresh the sender's "pending" checks (flips a request button to
	// "Requested") and any admin list showing the new message.
	onSuccess: () => {
		queryClient.invalidateQueries({ queryKey: ["communication", "pending"] });
		queryClient.invalidateQueries({ queryKey: ["admin", "communications"] });
	},
});
